<div class="cart-dhl content-without-footer d-flex w-100 position-relative">
    <app-cart [convenienceFees]="convenienceFees" [emptyCartMessage]="emptyCartMessage" class="position-absolute">
        <ng-container cart-header>
            <app-back-button class="back-button"> BACK </app-back-button>
        </ng-container>
    </app-cart>
</div>
